
  import { Component, Vue } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
	import PickerDate from '@/components/picker-date.vue';
  
  import {
    activitySignUpsignUpRecord
  } from "@/api/live"
  @Component({  
    name: '',
    components: {
      PageFooter,
      PickerDate
    }
  })

  export default class ProductList extends Vue {
    private keywords = ''
    private grade = null
    private gradelist = [
      {
				label: '全部',
				value: null
			}, {
				label: '联创',
				value: 1
			},{
				label: '核心',
				value: 2
			}, {
				label: '总代',
				value: 3
			}, 
    ]
    private pageSize = 20
    private pageNo = 1
    private total = 0
    private tablelist:any = []
    private tableloading = false


    private mounted () {
      this.gettablelist()
    }


    private exportfile(){
      let url = location.origin + '/pc/activitySignUp/signUpRecordExport'
      url += '?Id=' + this.$route.query.Id
      url += '&Keywords=' + encodeURIComponent(this.keywords)
      url += '&RoleGrade=' + (this.grade==null?'':this.grade)
      window.open(url)
    }
    private doSearch(){
      this.pageNo = 1
      this.gettablelist()
    }
    private clearSearch(){
      this.keywords = ''
      this.grade = null
      this.doSearch()
    }
    private async gettablelist(){
      try{
        this.tableloading = true
        let data:any = {
          Id:this.$route.query.Id,
          Keywords:this.keywords,
          RoleGrade:this.grade,
          Skip:(this.pageNo-1)*this.pageSize,
          Take:this.pageSize
        }
        let res:any = await activitySignUpsignUpRecord(data)
        if(res.IsSuccess){
          this.tablelist = res.Result.Results
          this.total = res.Result.Total
        }
      }finally{
        this.tableloading = false
      }
    }
    private changePage(e){
      this.pageNo = e
      this.gettablelist()
    }
  }
